import styled, { css } from 'styled-components';

export const Video = styled.video.withConfig({
  shouldForwardProp: (prop) => !['fill'].includes(prop),
})<{
  fill: boolean;
}>`
  ${({ fill }) =>
    fill &&
    css`
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
    `}
`;

export const VideoContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['aspectRatio'].includes(prop),
})<{
  aspectRatio: string;
}>`
  position: relative;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  overflow: hidden;

  &:fullscreen {
    background-color: black;
    /* width: 100% !important;
    height: 100% !important;
    margin: 0;
    padding: 0;
    aspect-ratio: auto; */

    iframe {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
      padding: 0;
      aspect-ratio: auto;
      background-color: black;
    }
  }

  video {
    transition: transform 0.5s;
  }

  div:not([class*='loader-spinner']) {
    position: relative;
    height: 100%;
    width: 100%;
  }

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 5;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 0;
  }

  button {
    all: unset;
    cursor: pointer;

    position: absolute;
    height: 35px;
    width: 35px;
    background: var(--c-black-200);
    border-radius: 5px;
  }

  .btn-fullscreen {
    right: 20px;
    bottom: 20px;
    z-index: 3;

    &:hover {
      img {
        transform: scale(1.05);
      }
    }
  }

  .btn-sound {
    right: 60px;
    bottom: 20px;
    z-index: 3;

    img {
      transform: scale(0.8);
      opacity: 1;
    }

    &:hover {
      img {
        transform: scale(0.85);
      }
    }
  }

  .exit-fullscreen-icon {
    opacity: 0;
  }
`;
